import { LabelId, UserCommunication } from '@this+that/models';

import { resolveLocalOnlySessionId } from './UserCommunications/draft/planCommunicationDeletion';
import { useComposeSnapshotIndexStore } from '../store/ComposeSnapshotIndex';

export const useHasSelectedDraftItems = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
) => {
  const entriesBySessionId = useComposeSnapshotIndexStore(
    (state) => state.entriesBySessionId,
  );
  const openComposeSessionIds = useComposeSnapshotIndexStore(
    (state) => state.openComposeSessionIds,
  );
  const backgroundSavingSessionIds = useComposeSnapshotIndexStore(
    (state) => state.backgroundSavingSessionIds,
  );

  const isDraftItemSelected = communications
    .filter((comm) => selectedItems.has(comm.messageId))
    .some(
      (comm) =>
        comm.labelIds?.includes(LabelId.DRAFT) ||
        Boolean(
          resolveLocalOnlySessionId(comm, entriesBySessionId, {
            openComposeSessionIds,
            backgroundSavingSessionIds,
          }),
        ),
    );

  return { isDraftItemSelected };
};
